export default __webpack_public_path__ + "static/media/archive.8c099027.svg";